// extracted by mini-css-extract-plugin
export default {"cell-container":"ylvY9dyNloF6CdtYJUBQ"};